import { Create, SimpleForm, ReferenceInput, SelectInput, BooleanInput, NumberInput, TextInput, useRedirect, useNotify } from 'react-admin';
import { Box, Typography } from '@mui/material';

export const AttendanceCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const onSuccess = () => {
    notify('Attendance record created', { type: 'success' });
    redirect('/attendance');
  };

  return (
    <Create mutationOptions={{ onSuccess }}>
      <SimpleForm>
        <Typography variant="h6" sx={{ mb: 2 }}>Record Attendance</Typography>
        <ReferenceInput source="session.id" reference="tutoring-sessions" label="Session" required>
          <SelectInput optionText="description" fullWidth />
        </ReferenceInput>
        <ReferenceInput source="student.id" reference="students" label="Student" required>
          <SelectInput optionText={(record: { legalEntity?: { firstName?: string; lastName?: string } }) => `${record.legalEntity?.firstName || ''} ${record.legalEntity?.lastName || ''}`.trim()} fullWidth />
        </ReferenceInput>
        <BooleanInput source="present" label="Present" defaultValue={true} />
        <NumberInput source="durationMinutes" label="Duration (minutes)" min={0} />
        <TextInput source="notes" label="Notes" multiline rows={3} fullWidth />
      </SimpleForm>
    </Create>
  );
};
